import EFPicture from '@elem/compCommon/EFPicture';
import css from './index.module.scss';
import { useGlobal } from '@/utils/useGlobal';

let sceneTextEnterD: any = null,
    sceneTextLeaveD: any = null;
export default function D() {
    const { useLang, useRouter, useEffect, useState, gtm, Link, useRef } = useGlobal();
    const { locale } = useRouter();
    const { t } = useLang('smart_home_panel_2.launch.detail');
    const [textEnter, setTextEnter] = useState(false);

    const [isH5, setIsH5] = useState(false);

    useEffect(() => {
        if (typeof window !== 'undefined') {
            setIsH5(window?.innerWidth <= 1024);
        }
    }, []);

    useEffect(() => {
        if (typeof window !== 'undefined') {
            const resizeAni = () => {
                if (sceneTextEnterD) {
                    AniContainer.removeScene(sceneTextEnterD);
                    sceneTextEnterD = null;
                }
                if (sceneTextLeaveD) {
                    AniContainer.removeScene(sceneTextLeaveD);
                    sceneTextLeaveD = null;
                }

                // const isOnlyH5 = window?.innerWidth < 768;
                //const textTarget = document.querySelector('.shp2-detail-D .text-info') as HTMLElement;
                //if (textTarget) {
                const clientH = (window.innerHeight || 0) * 0.2;
                const startH = Math.min(clientH, 150);
                sceneTextEnterD = AniContainer.create({
                    triggerElement: '.shp2-detail-D .text-info',
                    triggerHook: 1,
                    offset: startH,
                    duration: 200,
                    onEnter: () => setTextEnter(true),
                });
                //}
            };
            resizeAni();
            // window.addEventListener('resize', resizeAni);
            return () => {
                if (sceneTextEnterD) {
                    AniContainer.removeScene(sceneTextEnterD);
                    sceneTextEnterD = null;
                }
                if (sceneTextLeaveD) {
                    AniContainer.removeScene(sceneTextLeaveD);
                    sceneTextLeaveD = null;
                }
                // window.removeEventListener('resize', resizeAni);
            };
        }
    }, [isH5]);

    return (
        <section className={`shp2-detail-D shp2-detail-section ${css['shp2-detail-D']}`}>
            <div className={`text-info ${textEnter ? 'enter' : ''}`}>
                <h4 className="subtitle">{t('secD_subtitle')}</h4>
                <h2 className="title">{t('secD_title')}</h2>
                <p className="desc">
                    {t.rich('secD_desc', {
                        w: (text: string) => <span className="white">{text}</span>,
                    })}
                </p>
            </div>
            <div className="video-box">
                <EFPicture
                    src={'/responsive/picture/smart-home-panel-2/launch/4.jpg'}
                    srcPad={'/responsive/picture/smart-home-panel-2/launch/4_768.jpg'}
                    srcMobile={'/responsive/picture/smart-home-panel-2/launch/4_768.jpg'}
                    alt={t('secD_title')}
                />
                {/* {!isH5 && (
                    <video
                        className="video fullImgs"
                        // ref={videoRef}
                        // src={'/responsive/video/smart-home-panel-2/launch/4_pc.mp4'}
                        // autoPlay
                        muted
                        // loop
                        playsInline
                        preload="auto"
                        width="100%"
                        height="100%"
                        poster="/responsive/picture/smart-home-panel-2/launch/4.jpg"
                        aria-label={t('secD_title')}
                    />
                )}
                {isH5 && (
                    <video
                        className="video fullImgs"
                        // ref={videoRef}
                        // src={'/responsive/video/smart-home-panel-2/launch/4_h5.mp4'}
                        // autoPlay
                        muted
                        // loop
                        playsInline
                        preload="auto"
                        width="100%"
                        height="100%"
                        poster="/responsive/picture/smart-home-panel-2/launch/4_768.jpg"
                        aria-label={t('secD_title')}
                    />
                )} */}
                <p className="tip">{t('secD_tip')}</p>
            </div>
        </section>
    );
}
